import { spacing, Text } from '@scality/core-ui';
import { Input } from '@scality/core-ui/dist/next';
import type React from 'react';
import styled from 'styled-components';
import type { ControlComponentProps } from './types';

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.r4};
  min-width: 12rem;
`;

/** A free-text control. Stores a single value (empty string clears it). */
export const TextFieldControl: React.FC<ControlComponentProps> = ({ control, value, onChange, disabled }) => {
  const inputId = `dashboard-control-${control.key}`;
  return (
    <Field>
      <Text as="label" htmlFor={inputId} variant="Basic" color="textSecondary">
        {control.label}
      </Text>
      <Input
        id={inputId}
        type="text"
        autoComplete="off"
        noPlaceholderPrefix
        disabled={disabled}
        value={value[0] ?? ''}
        placeholder={`Filter by ${control.label.toLowerCase()}`}
        onChange={(event) => {
          const next = event.target.value;
          onChange(next ? [next] : []);
        }}
      />
    </Field>
  );
};
